export default "__VITE_ASSET__DZBmu1rZ__"